<template>
    <div class="col-md-12 px-0 py-0">
        <div class="my-3">
            <div class="form-inline">
                <div class="form-group">
                    <select
                        class="form-control"
                        placeholder="Seleccione año a buscar"
                        v-model="contestId"
                    >
                        <option value="0">Seleccione un concurso</option>
                        <option
                            :value="item.id"
                            v-for="item in contestList"
                            :key="item.id"
                        >
                            {{ item.name }} / v-{{ item.version }}
                        </option>
                    </select>
                </div>
                <button
                    type="button"
                    class="btn btn-primary ml-2"
                    @click="searchProjects()"
                >
                    Buscar
                </button>
            </div>
        </div>
        <table class="table table-bordered table-striped table-sm mt-5">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Concurso</th>
                    <th>Nombre</th>
                    <th>Responsable</th>
                    <th>Categoria</th>
                    <th>Pais</th>
                    <th>Accion</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(model, index) in arrayModel" :key="model.id">
                    <td v-text="model?.id"></td>
                    <td v-text="model?.contest?.name"></td>
                    <td v-text="model?.name"></td>
                    <td v-text="model?.user?.name"></td>
                    <td
                        v-text="model?.category ? model?.category?.name : ''"
                    ></td>
                    <td
                        v-text="model?.country ? model?.country?.name : ''"
                    ></td>
                    <td>
                        <button
                            v-if="!model.phase_3"
                            type="button"
                            @click="evaluateProject(model.id, 1, index)"
                            class="btn btn-success btn-sm"
                        >
                            Marcar como ganador
                        </button>
                        <button
                            v-if="model.phase_3"
                            type="button"
                            @click="evaluateProject(model.id, 2, index)"
                            class="btn btn-danger btn-sm"
                        >
                            Desmarcar ganador
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            contestId: "0",
            contestList: [],
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        searchProjects() {
            if (this.contestId > 0) {
                this.getListModel();
            }
        },
        getListContest() {
            let _this = this;
            axios
                .get("/api/contests?paginate=false")
                .then(function (response) {
                    _this.contestList = response.data;
                })
                .catch(function (error) {});
        },
        getListModel(page = 1) {
            let me = this;
            axios
                .get(
                    "/api/projects/get-finalists-by-contest?contest_id=" +
                        me.contestId + "&page=" + page
                )
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        evaluateProject(id, type, index) {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si!",
            }).then((result) => {
                if (result.value) {
                    me.arrayModel[index].phase_1 = 1;
                    axios
                        .put("/admin/project/winner/" + id, {
                            type: type,
                        })
                        .then(function (response) {
                            me.arrayModel[index].phase_3 =
                                response.data.phase_3;
                            me.showActionSuccess("Actualizacion exitosa!");
                        })
                        .catch(function (error) {});
                }
            });
        },
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page);
        },
    },
    mounted() {
        this.getListContest();
    },
};
</script>
